import React from "react";
import MainOptionsContainer from "./main-options/main-options-container";
import { useSelector } from "react-redux";
import { selectEditing, selectFinishedEditing } from "../customisation-slice";
import EditingBarContainer from "./editing-bar/editing-bar-container";
import SummaryContainer from "./summary/summary-container";
import FadeWrapper from "./fade-wrapper";
import { useSidebarAnimationContext } from "../providers/sidebar-animation-provider";

const SidebarContainer = () => {
  const editingKey = useSelector(selectEditing);
  const finishedEditing = useSelector(selectFinishedEditing);
  const { animationState } = useSidebarAnimationContext();

  return (
    <div className="w-full md:w-4/12 md:min-w-350 lg:w-3/12 bg-white">
      <FadeWrapper
        animationState={animationState}
        className="flex flex-col justify-between md:max-h-screen md:h-full"
      >
        {editingKey !== null && <EditingBarContainer />}
        {editingKey === null &&
          (!finishedEditing ? <MainOptionsContainer /> : <SummaryContainer />)}
      </FadeWrapper>
    </div>
  );
};

export default SidebarContainer;
